import { useBranding } from 'contexts/BrandingContext';
import { Typography, Box } from '@mui/material';

// ==============================|| LOGO - MAIN ||============================== //

export default function LogoMain() {
  const { branding, loading } = useBranding();

  // Construct the logo URL - use API base URL + branding path
  const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:8000/api';
  const baseUrl = apiUrl.replace('/api', '');

  // Use branding path if available, otherwise use default
  const logoPath = branding?.assets?.logo_path || '/branding/logo.svg';
  const logoUrl = `${baseUrl}${logoPath}`;
  const companyName = branding?.company?.name;

  // Show loading state or fallback to company name
  if (loading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {companyName}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      component="img"
      src={logoUrl}
      alt={companyName}
      sx={{
        height: '50px',
        width: 'auto',
        maxWidth: '200px',
        objectFit: 'contain'
      }}
      onError={(e) => {
        // On error, replace with company name text
        e.target.style.display = 'none';
        const textElement = document.createElement('span');
        textElement.textContent = companyName;
        textElement.style.fontSize = '1.25rem';
        textElement.style.fontWeight = '700';
        e.target.parentElement.appendChild(textElement);
      }}
    />
  );
}
